import { RuleCreatePageKey, RuleListPageKey } from '../../TModules';

export const translations = {
  [RuleListPageKey]: {
    SearchPlaceholder: 'Cerca regola per nome o ID',
    ApproveRequests: 'Approva richieste',
    CreateRule: 'Crea Regola',
    Rules: 'Regole',
    RuleActivatedSuccessfully: 'Regola attivata con successo.',
    ActivationRequestSubmittedForApproval: "Richiesta di attivazione inviata per l'approvazione.",
    RuleDeactivatedSuccessfully: 'Regola disattivata con successo.',
    RuleDeactivationRequestSubmittedForApproval:
      "Richiesta di disattivazione della regola inviata per l'approvazione.",
    MultipleApproveRequestSuccessMessage:
      "Richiesta multipla di approvazione inviata per l'approvazione.",
    ErrorApprovingRewards: "Errore nell'approvazione delle ricompense.",
    ApproveMultipleRequests: 'Approvare richieste multiple?',
    ApproveSelected: 'Approva selezionati',
    ApproveMultipleRequestsMessageLineOne:
      'Sei sicuro di voler approvare tutte le richieste selezionate?',
    ApproveMultipleRequestsMessageLineTwo:
      "Verifica i dettagli prima dell'approvazione poiché questa azione non può essere annullata.",
    ApproveRequestSuccessMessage: 'Messaggio di successo della richiesta di approvazione.',
    SomethingWentWrong: 'Qualcosa è andato storto.',
    ApproveRuleTitle: 'Approvare la regola?',
    SubmitDeletionRequestTitle: 'Inviare richiesta di eliminazione?',
    Approve: 'Approva',
    RequestDeletion: 'Richiedi eliminazione',
    ApproveRuleMessageLineOne: 'Sei sicuro di voler approvare questa regola?',
    ApproveRuleMessageLineTwo: 'Questa azione non può essere annullata.',
    SubmitDeletionRequestMessageLineOne:
      'Questa regola è in attesa di approvazione. Sei sicuro di volerla eliminare?',
    SubmitDeletionRequestMessageLineTwo:
      "Una volta approvata l'eliminazione, questa regola non sarà più disponibile e dovrai crearla di nuovo.",
    Tabs: {
      All: 'Tutti',
      Scheduled: 'Programmati',
      Active: 'Attivi',
      Inactive: 'Inattivi',
      Ended: 'Terminati',
      Pending: 'In attesa'
    },
    Columns: {
      RuleName: 'Nome Regola',
      Status: 'Stato',
      Comment: 'Commento',
      RequestType: 'Tipo di Richiesta',
      Balance: 'Saldo',
      StartDate: 'Data Inizio',
      EndDate: 'Data Fine',
      Trigger: 'Trigger',
      Outcome: 'Risultato',
      Actions: 'Azioni',
      ID: 'ID',
      Rule: 'Regola',
      Multiple: 'Multipli'
    },
    Errors: {
      ErrorActivatingRule: "Errore nell'attivazione della regola",
      ErrorDeactivatingRule: 'Errore nella disattivazione della regola'
    },
    Actions: {
      Show: 'Mostra',
      Approve: 'Approva',
      Review: 'Revisiona',
      Activate: 'Attiva',
      Deactivate: 'Disattiva',
      Duplicate: 'Duplica',
      Edit: 'Modifica'
    },
    CampaignRuleModal: {
      Create: 'Crea Regola Campagna',
      Edit: 'Modifica Regola Campagna',
      OkText: 'Aggiungi',
      UpdateText: 'Aggiorna',
      RuleName: 'Nome regola',
      RuleType: 'Tipo regola',
      RuleGetsTriggeredIf: 'La regola viene attivata se:',
      Priority: 'Priorità',
      RuleOutcome: 'Risultato regola',
      OutcomeType: 'Tipo risultato',
      OutcomeValue: 'Valore risultato',
      OutcomeValuePlaceholder: 'Inserisci valore risultato'
    },
    RuleTriggerLimitSegment: {
      TriggerLimits: 'Limiti trigger',
      TotalNumberOfTriggerEvents: 'Numero totale di eventi trigger (a livello campagna)',
      TriggerLimit: 'Limite trigger',
      TriggerLimitPlaceholder: '∞',
      TotalNumberOfTriggerEventsPerUser: 'Numero totale di eventi trigger (per utente)',
      TriggerRateLimitPerUser: 'Limite frequenza trigger (per utente)',
      LeaveTheLimitFieldsBlankForUnlimitedTriggerEvents:
        'Lascia i campi limite vuoti per eventi trigger illimitati',
      Days: 'Giorni',
      Weeks: 'Settimane',
      Months: 'Mesi',
      Years: 'Anni',
      TriggerEventsForEvery: 'evento/i trigger^ per ogni'
    },
    TransactionalFields: {
      ChooseOne: 'Scegli uno...',
      SelectTrigger: 'Seleziona Trigger',
      SelectOperator: 'Seleziona Operatore',
      AddCondition: 'Aggiungi Condizione',
      FromDate: 'Data Da',
      ToDate: 'Data A',
      And: 'E'
    },
    PersonalPropertyFilterField: {
      WhereHeader: 'QUANDO gli aggiornamenti del profilo includono',
      InfoNote:
        "La regola verrà attivata solo se l'aggiornamento del profilo modifica TUTTE le chiavi specificate con i valori specificati.",
      Key: 'Chiave',
      Value: 'Valore',
      Operator: 'Operatore',
      KeyPlaceholder: 'Chiave',
      ValuePlaceholder: 'Valore',
      SelectOperator: 'Seleziona operatore',
      PleaseSeparateValuesUsingComma: 'Si prega di separare i valori multipli con una virgola',
      AttributeLabel: 'Proprietà personale',
      Equals: 'Uguale a',
      NotEquals: 'Diverso da',
      In: 'In',
      NotIn: 'Non in',
      Like: 'Contiene',
      NotLike: 'Non contiene',
      KeyRequired: 'La chiave della proprietà è obbligatoria',
      OperatorRequired: "L'operatore è obbligatorio",
      OperatorInvalid: "L'operatore è obbligatorio",
      ValueRequired: 'Il valore è obbligatorio'
    },
    TransactionPropertyField: {
      PropertyDataType: 'Tipo dati proprietà',
      Key: 'Chiave',
      Sunday: 'Domenica',
      Monday: 'Lunedì',
      Tuesday: 'Martedì',
      Wednesday: 'Mercoledì',
      Thursday: 'Giovedì',
      Friday: 'Venerdì',
      Saturday: 'Sabato',
      Value: 'Valore',
      PleaseSeparateMultipleValuesUsingComma: 'Separa più valori usando la virgola',
      SelectOperator: 'Seleziona Operatore',
      Loading: 'Caricamento...',
      TableName: 'Nome Tabella',
      Type: 'Tipo',
      SampleValues: 'Valori di Esempio',
      Operator: 'Operatore'
    },
    AutomationFields: {
      SelectTrigger: 'Seleziona Trigger',
      ChooseOne: 'Scegli uno...',
      OutcomeType: 'Tipo risultato',
      SelectTriggerPlaceholder: 'Seleziona un trigger'
    },
    MerchantRewardSelectField: {
      SelectMerchant: 'Seleziona un Commerciante',
      Edit: 'Modifica',
      Add: 'Aggiungi',
      Merchant: 'Commerciante'
    },
    MerchantSelectModal: {
      Title: 'Seleziona un Commerciante',
      AddMerchant: 'AGGIUNGI COMMERCIANTE',
      Cancel: 'ANNULLA',
      SearchPlaceholder: 'Cerca commerciante per nome o ID',
      Active: 'Attivo',
      Inactive: 'Inattivo',
      Name: 'Nome',
      Status: 'Stato',
      DateCreated: 'Data Creazione',
      ID: 'ID'
    },
    RewardSelectField: {
      SelectReward: 'Seleziona una Ricompensa',
      Edit: 'Modifica',
      Add: 'Aggiungi',
      Reward: 'Ricompensa'
    },
    RewardSelectModal: {
      Title: 'Seleziona una Ricompensa',
      AddReward: 'Aggiungi Ricompensa',
      Cancel: 'Annulla',
      SearchPlaceholder: 'Trova una ricompensa per nome, ID o commerciante',
      All: 'Tutti',
      Active: 'Attivo',
      Approved: 'Approvato',
      Private: 'Privato',
      System: 'Sistema',
      Merchant: 'Commerciante',
      Balance: 'Saldo',
      SellingFrom: 'In vendita da',
      SellingTo: 'In vendita fino a',
      Reward: 'Ricompensa',
      RewardName: 'Nome Ricompensa',
      ID: 'ID'
    }
  },

  [RuleCreatePageKey]: {
    LoadingRule: 'Caricamento Regola',
    Steps: {
      SetupRule: 'Configura Regola',
      SetupAudience: 'Configura Pubblico',
      Review: 'Revisione'
    },
    EditMessage: {
      MakerCheckerSuccess: 'Richiesta inviata per approvazione',
      Success: 'Regola di automazione modificata con successo!',
      TransactionRulesError: 'Qualcosa è andato storto. Riprova più tardi.',
      RuleRequestError: "Errore durante la configurazione dell'automazione",
      TransactionRulesSuccess: 'Regola di automazione creata!',
      TransactionRulesMakerCheckerSuccess: 'Regola inviata per approvazione',
      TransactionRulesRequestError: "Errore durante la configurazione dell'automazione"
    },
    Cancel: 'Annulla',
    Back: 'Indietro',
    SaveAsDraft: 'Salva come bozza',
    Publish: 'Pubblica',
    Launch: 'Avvia',
    Next: 'Avanti',

    RuleSetup: {
      Essentials: 'Essenziali',
      Name: 'Nome',
      NamePlaceholder: 'Inserisci qui il nome della regola',
      Labels: 'Etichette',
      LabelsPlaceholder: 'Inserisci qui le tue etichette',
      Partner: 'Partner',
      PartnerPlaceholder: 'Seleziona il tuo partner',
      Owner: 'Proprietario',
      OwnerPlaceholder: 'Seleziona un proprietario',
      Mechanics: 'Meccaniche',
      ValidityPeriod: 'Periodo di Validità',
      TriggerLimits: 'Limiti Trigger',
      TotalNumberofTriggerEvents: 'Numero totale di eventi trigger (a livello campagna)',
      TotalNumberofTriggerEventsPerUser: 'Numero totale di eventi trigger (per utente)',
      TriggerRateLimitPerUser: 'Limite frequenza trigger (per utente)',
      TriggerRateLimitOnCampaignLevel: 'Limite frequenza trigger (a livello di campagna)',
      Days: 'Giorni',
      Weeks: 'Settimane',
      Months: 'Mesi',
      Years: 'Anni',
      LimitTo: 'Limita a',
      TriggerEvent: 'evento/i trigger^ per ogni',
      UnlimitedTriggerEvents: 'Lascia il campo limite vuoto per eventi trigger illimitati',
      Startdate: 'Data inizio',
      Enddate: 'Data fine',
      NoEnddate: 'Nessuna data fine',
      SelectATrigger: 'Seleziona un trigger:',
      SelectLoyaltyProgram: 'Seleziona Programma Fedeltà',
      SelectNextTier: 'Seleziona Livello Successivo',
      SelectCampaign: 'Seleziona Campagna',
      Custom: 'Personalizzato',
      Transaction: 'Transazione',
      Loyalty: 'Fedeltà',
      Reward: 'Ricompensa',
      Milestone: 'Campagna',
      Customer: 'Cliente',
      Location: 'Posizione',
      SelectTrigger: 'Seleziona Trigger',
      AgeingPointsHelp:
        "Il numero di punti in scadenza verrà controllato all'inizio di ogni ciclo di revisione.",
      AchievedNextTier: 'Raggiunto Livello Successivo',
      NearTier: '10% Vicino al Livello Successivo',
      PointsIssued: 'Punti Emessi',
      PointsEarnedorRedeemed: 'Punti guadagnati o riscattati',
      PointsEarnedOrRedeemed: 'Punti guadagnati o riscattati',
      SelectLoyaltyTransactionType: 'Seleziona il tipo di transazione di punti fedeltà',
      LoyaltyTransactionType: {
        earn: 'Guadagnare',
        burn: 'Riscattare'
      },
      LoyaltyConditions: {
        Attribute: {
          amount: 'Importo',
          transaction_properties: 'Ha la proprietà'
        },
        Operator: {
          equals: 'è uguale a',
          not_equals: 'è diverso da',
          greater_than: 'maggiore di',
          greater_than_or_equal_to: 'maggiore o uguale a',
          less_than: 'minore di',
          less_than_or_equal_to: 'minore o uguale a',
          in: 'in',
          not_in: 'non in',
          contains: 'contiene',
          not_contain: 'non contiene'
        }
      },
      AgeingPoints: 'Punti in scadenza (punti che stanno per scadere nel ciclo corrente)',
      RedeemReward: 'Riscatta Ricompensa',
      IssueReward: 'Emetti Ricompensa',
      IssueRewardFromCampaign: 'Emetti Ricompensa dalla Campagna',
      IssueRewardFromMerchant: 'Emetti Ricompensa dal Commerciante',
      VoucherForParticularRewardExpiringIn: 'Voucher per una Ricompensa specifica in scadenza tra',
      AnyVoucherExpiringIn: 'Qualsiasi voucher in scadenza tra {days} giorni',
      StampRedeemed: 'Timbro Riscattato',
      StampsIssued: 'Timbri Emessi',
      StampsInactive: 'Timbri Inattivi',
      GamePlayed: 'Gioco Giocato',
      GameTryIssued: 'Tentativo di Gioco Emesso',
      CampaignEnrolled: 'Iscritto alla Campagna',
      CampaignCompleted: 'Campagna Completata',
      CampaignNotCompleted: 'Campagna Non Completata',
      ProgressLevelAchieved: 'Livello di Progresso Raggiunto',
      ProgressRuleTriggered: 'Regola di Progresso Attivata',
      QuestTaskCompleted: 'Attività Quest Completata',
      SignUp: 'Registrazione',
      SignIn: 'Accesso',
      ProfileUpdated: 'Profilo Aggiornato',
      LoyaltyProgramSelectPlaceholder: 'Seleziona programma fedeltà',
      SelectTriggerPlaceholder: 'Seleziona un trigger'
    },

    MilestoneField: {
      SelectStampCampaign: 'Seleziona una Campagna Timbri',
      Change: 'Modifica',
      Select: 'Seleziona',
      StampCampaign: 'Campagna Timbri',
      AnyRewardsSelected:
        'Qualsiasi ricompensa {isCampaignRewardsSelected} in questa campagna sarà un trigger',
      SelectStampsSlot: 'Seleziona Slot Timbri',
      SelectStampPosition: 'Seleziona Posizione Carta Timbri'
    },

    CampaignSelectField: {
      Interval: 'Intervallo',
      Days: '(Giorni)',
      SelectStampCampaign: 'Seleziona una Campagna Timbri',
      Change: 'Modifica',
      Select: 'Seleziona',
      StampCampaign: 'Campagna Timbri',
      SelectACampaign: 'Seleziona una Campagna',
      Edit: 'Modifica',
      Add: 'Aggiungi',
      Campaign: 'Campagna',
      ID: 'ID',
      SelectAMilestone: 'Seleziona un Traguardo',
      SelectARule: 'Seleziona una Regola',
      SelectATask: "Seleziona un'Attività"
    },

    GameSelectField: {
      SelectAGameCampaign: 'Seleziona una Campagna Gioco',
      Game: 'Gioco',
      Campaign: 'Campagna',
      Change: 'Modifica',
      Select: 'Seleziona'
    },

    CampaignRewardSelectField: {
      SelectACampaign: 'Seleziona una Campagna',
      Change: 'Modifica',
      Select: 'Seleziona',
      Campaign: 'Campagna',
      SelectAReward: 'Seleziona una Ricompensa (Opzionale)',
      Reward: 'Ricompensa',
      ID: 'ID'
    },

    MerchantRewardSelectField: {
      SelectAMerchant: 'Seleziona un Commerciante',
      Change: 'Modifica',
      Select: 'Seleziona',
      Merchant: 'Commerciante',
      AddMerchant: 'Aggiungi Commerciante',
      Cancel: 'Annulla',
      SearchMerchant: 'Cerca commerciante per nome o ID',
      Active: 'Attivo',
      Inactive: 'Inattivo',
      ID: 'ID'
    },

    RewardSelectField: {
      SelectAReward: 'Seleziona una Ricompensa (Opzionale)',
      Change: 'Modifica',
      Reward: 'Ricompensa',
      Select: 'Seleziona',
      WarningText:
        'Il Tipo di Risultato è limitato a [Push Event] quando viene selezionata una ricompensa di Sistema'
    },

    RewardExpirySetupField: {
      SelectAReward: 'Seleziona una Ricompensa',
      Change: 'Modifica',
      Select: 'Seleziona',
      Reward: 'Ricompensa',
      Periods: 'Periodi (Giorni)'
    },

    CheckInFields: {
      EnterLocationDetails: 'Inserisci Dettagli Posizione',
      Latitude: 'Latitudine',
      Longitude: 'Longitudine',
      Radius: 'Raggio',
      DegreesLatitude: 'Gradi (-90.0 a 90.0)',
      DegreesLongitude: 'Gradi (-180.0 a 180.0)',
      PermissibleRadiusInMeter: 'Raggio Consentito (In Metri)',
      PermissibleRadius: 'Raggio Consentito',
      Preview: 'ANTEPRIMA'
    },

    OutcomeSection: {
      Outcome: 'Risultato:',
      MediaTagsToInclude: 'Tag Media da Includere',
      SelectMediaTags: 'Seleziona Tag Media',
      SelectLoyaltyProgram: 'Seleziona Programma Fedeltà',
      SelectPointEarnType: 'Seleziona Tipo Accumulo Punti',
      FixedPoints: 'Punti Fissi',
      VariablePoints: 'Punti Variabili',
      NumberOfPoints: 'Numero di Punti',
      PointsSignHint:
        '(Inserisci un numero positivo per aggiungere punti e un numero negativo per sottrarli.)',
      Award: 'Premio',
      ForEvery: 'Per Ogni',
      UpToAMaximumOf: 'Fino a un massimo di',
      Currency: 'Valuta',
      SelectGLAccount: 'Seleziona Conto GL',
      GLAccountName: 'Nome Conto GL',
      GLAccountNamePlaceholder: 'nome conto gl',
      Points: 'Punti',
      GLAccountType: 'Tipo Conto GL',
      GLAccountTypePlaceholder: 'tipo conto gl',
      EnterKeyName: 'Inserisci il nome della chiave',
      KeyName: 'Nome della chiave',
      EnterValueDetails: 'Inserisci i dettagli del valore',
      KeyValue: 'Valore della chiave',
      AddMore: 'Aggiungi Altro'
    },

    OutcomeList: {
      RemoveOutcome: 'Rimuovi il risultato in posizione {{position}}',
      MaxOutcomesReached: 'Una regola può avere al massimo 10 risultati.',
      AddOutcome: 'Aggiungi risultato',
      Position: 'Posizione {{position}}',
      Then: 'POI:',
      SequentialExecutionNotice: 'I risultati vengono eseguiti in sequenza',
      OutcomeIdMatchesType:
        'Questo risultato non corrisponde al tipo selezionato. Selezionalo di nuovo.'
    },

    OutcomeTypeField: {
      SelectOutcomeType: 'Seleziona Tipo Risultato',
      Campaign: 'Campagna',
      Rewards: 'Ricompense',
      Points: 'Punti',
      Audience: 'Pubblico',
      UpdateCustomerDetails: 'Aggiorna Dettagli Cliente',
      PushEventOnly: 'Solo Push Event',
      CustomFieldsTitle: 'Campi Personalizzati',
      AddCustomField: '+ Aggiungi Campo Personalizzato',
      CustomFieldValidation: '{title} è obbligatorio.',

      CustomFields: {
        Key: 'Chiave',
        Value: 'Valore',
        CustomFieldsError: 'Seleziona i campi personalizzati corretti!',
        UniqueKeyError: 'La chiave deve essere unica!'
      }
    },

    OutcomeCampaignSelectField: {
      SelectCampaignType: 'Seleziona Tipo Campagna',
      Stamp: 'Timbro',
      Game: 'Gioco',
      Quiz: 'Quiz',
      Survey: 'Sondaggio',
      SelectCampaign: 'Seleziona una Campagna',
      Change: 'Modifica',
      Select: 'Seleziona',
      Campaign: 'Campagna',
      BonusStamps: 'Timbri Bonus',
      BonusTries: 'Tentativi Bonus'
    },

    OutcomeRewardSelectField: {
      SelectReward: 'Seleziona una Ricompensa',
      Change: 'Modifica',
      Reward: 'Ricompensa',
      Select: 'Seleziona',
      OnlySystemRewardsShown: 'Sono mostrate solo le ricompense di sistema.'
    },

    OutcomePointExpiry: {
      OutcomeExpiresAt: 'Il Risultato Scade Il'
    },

    OutcomeAudienceField: {
      SelectAudienceList: 'Seleziona Lista Pubblico',
      SelectAudienceListPlaceholder: 'Seleziona Lista Pubblico'
    },

    LoyaltyAudience: {
      SelectAudience: 'Seleziona un Pubblico',
      DefaultAudience: 'Crea un pubblico monouso per questa campagna',
      ExistingAudience: 'Seleziona un pubblico esistente',
      AudienceSetup: 'Configurazione pubblico',
      SelectAudienceV4Placeholder: 'Seleziona pubblico',
      SelectFilters: 'Seleziona filtri',
      SelectedFilters: 'Filtri selezionati',
      NoFiltersSelected: 'Nessun filtro selezionato',

      AudienceListSetup: {
        Include: 'Includi',
        Exclude: 'Escludi',
        AudienceExistsMessage:
          'Impossibile {{audienceIncludeExclude}} pubblico già impostato per {{audienceIncludeExcludeNoun}}',
        PickAudienceList: 'Scegli una lista pubblico',

        Includes: 'Include',
        Excludes: 'Esclude',
        AudienceWarningMessage:
          "Il file del pubblico caricato verrà elaborato solo dopo l'approvazione da parte di un Approvatore Azioni di Massa",
        SelectedFileForInclusion: "File selezionato per l'inclusione",
        AudienceNotInTheList: 'Pubblico non in lista',
        IncludeAudienceFilenamePlaceholder: 'Nomina la lista del pubblico incluso',
        UploadNow: 'Carica ora',
        UploadNewList: 'Carica nuova lista',
        AcceptedFormat: 'Formato accettato: solo file .xlsx/.csv.',
        DownloadSample: 'Scarica esempio',
        UploadExclusion: 'Carica Esclusione',
        SelectedFileForExclusion: "File selezionato per l'esclusione",
        ExcludeAudienceFilenamePlaceholder: 'Nomina la lista del pubblico escluso',

        SubmittingData: 'Invio dati in corso...',
        SomethingWentWrong: 'Qualcosa è andato storto.',
        AutoCreateCustomers: 'Crea anche i clienti se non esistono'
      },

      AudienceFilters: {
        Age: 'Età',
        BirthMonth: 'Mese di Nascita',
        Gender: 'Genere',
        Location: 'Posizione',
        Loyalty: 'Fedeltà',
        Personal: 'Personale',
        Custom: 'Personalizzato',
        EmailTags: 'Tag Email',
        Ethnicity: 'Etnia',
        SelectCustomerAttributeFilters: 'Seleziona i filtri attributo-cliente:',
        NoFiltersSelected: 'Nessun filtro selezionato',
        And: 'e',
        Badge: 'Badge',
        Campaign: 'Campagna',
        Leaderboard: 'Classifica',
        LoyaltyPoints: 'Punti Fedeltà',
        LoyaltyTier: 'Livello Fedeltà',
        MemberSince: 'Membro dal',
        Reward: 'Ricompensa',
        Filter: 'Basato su Pagamento',
        Payment: 'Pagamento',
        SelectFilters: 'Seleziona filtri per generare automaticamente una lista pubblico',
        City: 'Città',
        States: 'Stati',

        OfferId: 'ID Offerta',
        PrimaryClusterComb: 'Combinazione Cluster Primario',
        PrimaryClusterState: 'Stato Cluster Primario',
        Membership: 'Membro Di',
        CurrentBirthday: 'Solo Durante il Giorno di Nascita',
        CurrentBirthMonth: 'Solo Durante il Mese di Nascita',
        HasBirthday: 'Nel Compleanno',
        UserType: 'Tipo Utente',
        AccountConfirmedAt: 'Registrato tra',
        LoyaltyPointsBalance: 'Saldo punti',
        CampaignEnrolment: 'Campagna',
        LeaderboardPosition: 'Posizione in Classifica',
        UPI: 'UPI',
        ScanPay: 'Scan pay',
        BBPS: 'BBPS',
        KYC: 'KYC',
        CurrentAddress: 'Indirizzo attuale',
        PaymentStatus: 'Stato pagamento',
        DaysPastDues: 'Giorni di ritardo',
        BNPLUnpaidEMIDate: 'Data EMI non pagata BNPL',
        InstaloanUnpaidEMIDate: 'Data EMI non pagata Instaloan',

        AgeFilter: {
          Title: 'Età',
          Includes: 'Include',
          Excludes: 'esclude',
          SelectPlaceholder: 'Include',
          From: 'età da',
          FromPlaceholder: '18',
          To: 'a',
          ToPlaceholder: '35',
          AddRange: 'Aggiungi intervallo',
          And: 'e'
        },
        BirthdayFilter: {
          Title: 'Compleanno',
          SelectBirthMonth: 'Seleziona mese di nascita',
          BirthMonth: 'Mese di nascita',
          CurrentBirthMonth: 'Mese di Nascita Corrente',
          OnlyDuringMonthOfBirth: 'Solo Durante il Mese di Nascita',
          HasBirthday: 'Ha compleanno',
          OnBirthday: 'Nel compleanno',
          Includes: 'Include',
          Excludes: 'Esclude'
        },
        GenderFilter: {
          Title: 'Genere',
          SelectByGender: 'Seleziona per Genere',
          Male: 'Maschio',
          Female: 'Femmina'
        },
        EthnicityFilter: {
          Title: 'Etnia',
          SelectEthnicity: 'Seleziona Etnia',
          SelectEthnicityPlaceholder: 'Seleziona etnia',
          Include: 'Includi',
          Exclude: 'Escludi',
          Includes: 'Include',
          Excludes: 'esclude'
        },
        LocationFilter: {
          Title: 'Posizione',
          SelectCity: 'Seleziona Città',
          Include: 'Includi',
          Exclude: 'Escludi',
          SelectCityPlaceholder: 'Seleziona città',
          SelectState: 'Seleziona Stato',
          SelectStatePlaceholder: 'Seleziona stato',
          Includes: 'Include',
          Excludes: 'Esclude'
        },

        PersonalFilter: {
          Title: 'Personale',
          HubClub: 'Hub Club',
          Select: 'Seleziona',
          Include: 'Includi',
          Exclude: 'Escludi',
          AddCustomProperties: 'Aggiungi proprietà personalizzate',
          EnterKeyNameAndValueDetails: 'Inserisci nome chiave e dettagli valore',
          SelectRelation: 'Seleziona relazione',
          EnterNumber: 'Inserisci numero',
          KeyValue: 'Valore chiave',
          DatePlaceholder: 'GG-MM-AAAA',
          KeyNamePlaceholder: 'Nome chiave',
          Is: 'È',
          True: 'Vero',
          False: 'Falso',
          And: 'E',
          Or: 'O',
          CustomAttributeType: 'Attributo personalizzato #{{index}}: tipo',
          CustomAttribute: 'Attributo personalizzato #{{index}}: attributo',
          CustomAttributeOperator: 'Attributo personalizzato #{{index}}: operatore',
          CustomAttributeValue: 'Attributo personalizzato #{{index}}: valore',
          Includes: 'include',
          Excludes: 'esclude'
        },

        LoyaltyFilter: {
          Title: 'Fedeltà',
          SelectLoyaltyProgram: 'Seleziona Programma Fedeltà',
          Include: 'Includi',
          Exclude: 'Escludi',
          SelectProgram: 'Seleziona programma',
          Includes: 'Include',
          Excludes: 'Esclude',
          UsersWhoAchieved: 'Utenti che hanno raggiunto',
          SelectProgramAndTier: 'Seleziona programma e livello',
          UsersWithPointsBalance: 'Utenti con saldo punti',
          SelectLoyaltyProgramPlaceholder: 'Seleziona programma fedeltà',
          From: 'Da',
          To: 'A',
          PointsBalanceFrom: 'Saldo punti da',
          PointsBalanceTo: 'Saldo punti a'
        },

        EmailTagsFilter: {
          Includes: 'Include',
          SelectEmailTags: 'Seleziona tag email',
          Excludes: 'Esclude'
        },

        PaymentBasedFilter: {
          IncludeUsersWith: 'Includi utenti con',
          UPI: 'UPI',
          ScanPay: 'Scan pay',
          BBPS: 'BBPS',
          KYC: 'KYC',
          CurrentAddress: 'Indirizzo attuale',
          PaymentStatus: 'Stato pagamento',
          DaysPastDues: 'Giorni di ritardo',
          BNPLUnpaidEMIDate: 'Data EMI non pagata BNPL',
          InstaloanUnpaidEMIDate: 'Data EMI non pagata Instaloan',
          SelectFromList: 'Seleziona dalla lista',
          SelectDate: 'Seleziona Data',
          Upcoming: 'In arrivo',
          DueNow: 'Scaduto ora',
          Future: 'Futuro',
          Overdue: 'Scaduto',
          None: 'Nessuno',
          Includes: 'Inclut',
          Excludes: 'Exclut'
        }
      }
    },

    RuleDetail: {
      Title: 'Dettaglio Regola',
      RuleName: 'Nome Regola',
      Status: 'Stato',
      StartTime: 'Ora Inizio',
      EndTime: 'Ora Fine',
      Labels: 'Etichette',
      Notification: 'Notifica',
      Owner: 'Proprietario',
      Partner: 'Partner',
      On: 'ATTIVO',
      Off: 'DISATTIVO',
      Merchant: 'Commerciante',
      Trigger: 'Trigger',
      TriggerType: 'Tipo Trigger',
      TriggerEventName: 'Nome Evento Trigger',
      Conditions: 'Condizioni',
      Campaign: 'Campagna',
      Reward: 'Ricompensa',
      Loyalty: 'Fedeltà',
      Tier: 'Livello',
      AutomationTrigger: 'Trigger Automazione',
      TotalTriggerLimit: 'Limite Totale Trigger',
      UserLifetimeLimit: 'Limite Vita Utente',
      TriggerLimitPerUser: 'Limite Trigger (per utente)',
      TriggerLimitOnCampaignLevel: 'Limite Trigger (a livello campagna)',
      Outcome: 'Risultato',
      OutcomeType: 'Tipo Risultato',
      OutcomeProperties: "Proprietà dell'esito",
      OutcomePropertyKey: 'Chiave',
      OutcomePropertyValue: 'Valore',
      GLAccountNumber: 'Numero Conto GL',
      GLAccountName: 'Nome Conto GL',
      CostCenterId: 'ID Centro di Costo',
      BranchCode: 'Codice Filiale',
      AudienceInfo: 'Info Pubblico',
      TimesPerUser: 'Volte Per',
      ID: 'ID'
    },

    CampaignDetail: {
      CampaignID: 'ID Campagna',
      CampaignName: 'Nome Campagna',
      CampaignType: 'Tipo Campagna',
      BonusStamps: 'Timbri Bonus',
      BonusTries: 'Tentativi Bonus'
    },

    RewardDetail: {
      RewardID: 'ID Ricompensa',
      RewardName: 'Nome Ricompensa'
    },

    LoyaltyDetail: {
      CampaignName: 'Nome Campagna',
      Points: 'Punti',
      OutcomeExpiresAt: 'Il Risultato Scade Il',
      ForEvery: 'Per Ogni',
      UpToAMaximumOf: 'Fino a un massimo di'
    },

    LoyaltyTier: {
      NextTiers: 'Livelli Successivi',
      NextTier: 'Livello Successivo'
    },

    AutomationTrigger: {
      AutomationTrigger: 'Trigger Automazione'
    },

    RuleRequestComment: {
      Content: 'Contenuto',
      DeleteButton: 'Pulsante Elimina',
      UserDescription: 'Descrizione Utente',
      UserRole: 'Ruolo Utente',
      Description: 'Descrizione',
      Delete: 'Elimina',
      Time: 'Ora',
      PendingRule: 'Regola in Attesa',
      Approve: 'Approva',
      AddComment: 'Aggiungi Commento',
      ViewAndAddComments: 'Visualizza e aggiungi commenti',
      ApproveRule: 'Approva regola',
      PendingRuleDescription:
        'Questa regola è in attesa di approvazione. Eventuali commenti aggiunti appariranno qui.',
      CommentsAdded: 'commenti aggiunti'
    },

    DeleteCommentModal: {
      SuccessMessage: 'Commento eliminato',
      ErrorMessage: "Errore durante l'eliminazione del commento",
      Title: 'Eliminare il commento?',
      OkText: 'Elimina',
      DescriptionLineOne: 'Sei sicuro di voler eliminare il tuo commento?',
      DescriptionLineTwo: 'Questa azione non può essere annullata.',
      CancelText: 'Annulla'
    },

    ApproveDenyCampaignRequestModalTitle: 'Approvare la campagna?',
    ApproveDenyCampaignRequestModalButton: 'Approva',

    ApproveDenyCampaignRequestModal: {
      SuccessMessage: 'La richiesta è stata approvata',
      ErrorMessage: 'Qualcosa è andato storto',

      ApproveTitle: 'Approvare la campagna?',
      Title: 'Inviare richiesta di eliminazione?',
      ApproveOkText: 'Approva',
      OkText: 'Richiedi eliminazione',
      CancelText: 'Annulla',

      ApproveDescriptionLineOne: 'Sei sicuro di voler approvare questa campagna?',
      ApproveDescriptionLineTwo: 'Questa azione non può essere annullata.',

      DescriptionLineOne:
        'Questa regola è in attesa di approvazione. Sei sicuro di volerla eliminare?',
      DescriptionLineTwo:
        "Una volta approvata l'eliminazione, questa regola non sarà più disponibile e dovrai crearla di nuovo.",
      ApproveRuleTitle: 'Approvare la regola?',
      SubmitDeletionRequestTitle: 'Inviare richiesta di eliminazione?',
      RequestDeletionOkText: 'Richiedi eliminazione',
      ApproveRuleDescriptionLineOne: 'Sei sicuro di voler approvare questa regola?',
      ApproveRuleDescriptionLineTwo: 'Questa azione non può essere annullata.'
    },

    AddCommentModalTitle: 'Visualizza e aggiungi commenti',
    AddCommentModalButton: 'Aggiungi Commento',
    AddCommentModal: {
      SuccessMessage: 'Commento aggiunto',
      ErrorMessage: "Errore durante l'aggiunta del commento",
      CancelText: 'Annulla',
      CommentInputPlaceholder: 'Inserisci qui il tuo commento',
      AddCommentButton: 'Aggiungi commento'
    },

    AudienceInfoTitle: 'Info Pubblico',

    AudienceInfo: {
      Description: 'Pubblico selezionato:',
      NoListsSelected: 'Nessuna lista selezionata',
      Include: 'Includi',
      Exclude: 'Escludi',
      AudienceAttributes: 'Attributi pubblico',
      AudienceList: 'Lista pubblico',
      NoFiltersSelected: 'Nessun filtro selezionato'
    },

    AudienceInfoFilters: {
      Loyalty: 'Fedeltà',
      Gender: 'Genere',
      Age: 'Età',
      BirthMonth: 'Mese di Nascita',
      Ethnicity: 'Etnia',
      MakerCheckerSuccess: 'Request submitted for approval',
      Success: 'Automation Rule edited successfully!',
      TransactionRulesError: 'Something went wrong. Please try again later.',
      RuleRequestError: 'Error setting up automation',
      TransactionRulesSuccess: 'Automation Rule created!',
      TransactionRulesMakerCheckerSuccess: 'Rule submitted for approval',
      TransactionRulesRequestError: 'Error setting up automation'
    }
  }
};
